export default {
    state: {
        dialogVisible: false
    },
    showAccountInfo() {
        this.state.dialogVisible = true;
    },
    dismiss() {
        this.state.dialogVisible = false;
    }
}
